import { zodResolver } from '@hookform/resolvers/zod'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { z } from 'zod'

import { makeZodI18nMap } from './make-zod-i18n-map'

export const useZodResolver = ({
  schema,
  tFormFields,
}: {
  schema: z.ZodSchema
  tFormFields: typeof useTranslations.apply
}) => {
  const zodTranslations = useTranslations('Zod')
  return useMemo(() => {
    return zodResolver(schema, {
      errorMap: makeZodI18nMap({ t: zodTranslations, tForm: tFormFields }),
    })
  }, [zodTranslations, tFormFields, schema])
}
